export const adminColors = {
  bg: {
    page: '#0A0A0A',
    surface: '#111827',
    card: '#1A1A2E',
    input: '#0F1629',
    hover: '#1E293B'
  },
  text: {
    primary: '#E6EEF7',
    secondary: '#9CA3AF',
    muted: '#6B7280',
    disabled: '#4B5563'
  },
  border: {
    default: '#374151',
    hover: '#4B5563',
    focus: '#0FA3A3'
  },
  accent: {
    gold: '#D4AF37',
    goldLight: '#EBC14F',
    goldDark: '#B8962E',
    teal: '#0FA3A3',
    tealLight: '#2FC9C6',
    tealDark: '#0C8A8A'
  },
  primary: {
    main: '#191970',
    light: '#4F8FFF',
    dark: '#062A5A'
  },
  status: {
    success: '#16A34A',
    successBg: 'rgba(22, 163, 74, 0.15)',
    warning: '#F59E0B',
    warningBg: 'rgba(245, 158, 11, 0.15)',
    error: '#EF4444',
    errorBg: 'rgba(239, 68, 68, 0.15)'
  }
};

export const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    color: adminColors.text.primary,
    backgroundColor: adminColors.bg.input,
    borderRadius: '8px',
    '& fieldset': {
      borderColor: adminColors.border.default,
      borderWidth: '1px'
    },
    '&:hover fieldset': {
      borderColor: adminColors.border.hover
    },
    '&.Mui-focused fieldset': {
      borderColor: adminColors.accent.teal,
      borderWidth: '2px'
    },
    '&.Mui-disabled': {
      backgroundColor: adminColors.bg.hover,
      '& fieldset': {
        borderColor: adminColors.border.default
      }
    }
  },
  '& .MuiInputLabel-root': {
    color: adminColors.text.secondary,
    '&.Mui-focused': {
      color: adminColors.accent.teal
    }
  },
  '& .MuiFormHelperText-root': {
    color: adminColors.text.muted
  },
  '& .MuiSelect-icon': {
    color: adminColors.text.secondary
  },
  '& .MuiInputBase-input::placeholder': {
    color: adminColors.text.muted,
    opacity: 1
  }
};

export const selectMenuProps = {
  PaperProps: {
    sx: {
      bgcolor: adminColors.bg.card,
      border: `1px solid ${adminColors.border.default}`,
      '& .MuiMenuItem-root': {
        color: adminColors.text.primary,
        '&:hover': {
          bgcolor: adminColors.bg.hover
        },
        '&.Mui-selected': {
          bgcolor: `${adminColors.accent.teal}20`,
          '&:hover': {
            bgcolor: `${adminColors.accent.teal}30`
          }
        }
      }
    }
  }
};

export const dialogStyles = {
  bgcolor: adminColors.bg.card,
  backgroundImage: 'none',
  border: `1px solid ${adminColors.border.default}`,
  borderRadius: '12px',
  color: adminColors.text.primary
};

export const tabStyles = (isActive) => ({
  color: isActive ? adminColors.accent.teal : adminColors.text.secondary,
  fontWeight: isActive ? 600 : 400,
  '&.Mui-selected': {
    color: adminColors.accent.teal
  }
});

export const chipStyles = {
  published: {
    bgcolor: adminColors.status.successBg,
    color: adminColors.status.success,
    fontWeight: 500
  },
  draft: {
    bgcolor: adminColors.status.warningBg,
    color: adminColors.status.warning,
    fontWeight: 500
  },
  type: (color) => ({
    bgcolor: `${color}20`,
    color: color,
    fontWeight: 500
  })
};

export const tableStyles = {
  container: {
    bgcolor: adminColors.bg.surface,
    borderRadius: '12px',
    border: `1px solid ${adminColors.border.default}`,
    overflow: 'hidden'
  },
  headerCell: {
    color: adminColors.text.secondary,
    fontWeight: 600,
    borderBottom: `1px solid ${adminColors.border.default}`,
    bgcolor: adminColors.bg.card,
    py: 2
  },
  bodyCell: {
    color: adminColors.text.primary,
    borderBottom: `1px solid ${adminColors.border.default}`,
    py: 2
  },
  row: {
    '&:hover': {
      bgcolor: adminColors.bg.hover
    },
    '&:last-child td': {
      borderBottom: 'none'
    }
  }
};

export const buttonStyles = {
  primary: {
    bgcolor: adminColors.accent.gold,
    color: '#111827',
    fontWeight: 600,
    px: 3,
    '&:hover': {
      bgcolor: adminColors.accent.goldDark
    },
    '&:disabled': {
      bgcolor: adminColors.text.disabled,
      color: adminColors.text.muted
    }
  },
  secondary: {
    color: adminColors.text.secondary,
    '&:hover': {
      bgcolor: adminColors.bg.hover,
      color: adminColors.text.primary
    }
  },
  iconEdit: {
    color: adminColors.accent.teal,
    '&:hover': {
      bgcolor: `${adminColors.accent.teal}20`
    }
  },
  iconDelete: {
    color: adminColors.status.error,
    '&:hover': {
      bgcolor: adminColors.status.errorBg
    }
  }
};

export const switchStyles = {
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: adminColors.accent.teal,
      '& + .MuiSwitch-track': {
        bgcolor: adminColors.accent.teal,
        opacity: 0.5
      }
    }
  },
  '& .MuiSwitch-track': {
    bgcolor: adminColors.border.default
  }
};
